import log from "loglevel"
import { create } from "zustand"
import { API, NexusSuccessResponse } from "../api/API"

interface DbState {
    backendVersion: string
    databaseName: string
    databaseVersion: string
}

interface DbStateStoreState {
    /**
     * Undefined indicates the DB version is being loaded
     */
    success?: boolean
    dbState?: DbState
    userMgmtUrl?: string
    error?: string
    fetchDbState: () => Promise<void>
}

export const useDbStateStore = create<DbStateStoreState>((set) => ({
    fetchDbState: async () => {
        set({ success: undefined, error: undefined })
        let failureMessage: string | undefined
        try {
            const result: NexusSuccessResponse<{
                database_name: string
                database_version: string
                user_mgmt_url: string
                backend_version: string
            }> = await API.get(
                "/version",
                "There was an unexpected error connecting to the Nexus service. Please contact " +
                    "Nexus support or refresh the page and try again.",
            )

            if (result.data.user_mgmt_url == null) {
                failureMessage =
                    "The Nexus service could not find the user management URL. Please contact Nexus support."
            } else {
                const dbState = {
                    databaseName: result.data.database_name,
                    databaseVersion: result.data.database_version,
                    backendVersion: result.data.backend_version,
                }
                log.info(
                    `Nexus Version Info: ${JSON.stringify(
                        {
                            userMgmtUrl: result.data.user_mgmt_url,
                            ...dbState,
                        },
                        null,
                        2,
                    )}`,
                )
                // Success!
                set({
                    success: true,
                    userMgmtUrl: result.data.user_mgmt_url,
                    dbState,
                })
            }
        } catch (error) {
            log.error(error)
            failureMessage = error.message
        }

        if (failureMessage != null) {
            // Oh no there was an error!
            log.error(`Error fetching database state: ${failureMessage}`)
            set({
                success: false,
                userMgmtUrl: undefined,
                dbState: undefined,
                error: failureMessage,
            })
        }
    },
}))
